<template>
    <div class="vue-delete-form">
        <div>
            <div class="text-center">
                <h3 class="text-lg leading-5 font-bold text-gray-900">
                    Are you sure?
                </h3>
                <div v-if="data.name" class="text-center mt-5">
                    <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800" v-text="data.name" />
                </div>
            </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
            <button type="button" v-on:click="onSubmit" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:col-start-2 sm:text-sm">
                Delete
            </button>
            <button type="button" v-on:click="onCancle" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm">
                Cancel
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            data: null,
        },
        data() {
            return {
                //
            };
        },
        mounted() {
            //
        },
        created() {
            //
        },
        destroyed() {
            //
        },
        computed: {
            //
        },
        methods: {
            onCancle() {
                this.$root.closeModal();
            },
            onSubmit() {
                axios.delete(this.data.endpoint, { uuid: this.data.uuid })
                    .then((response) => {
                       location.reload();
                   })
                   .catch((error) => {
                       //
                   })
                   .then(() => {
                       // this.$root.closeModal();
                   });
            }
        },
    };
</script>
